import { h } from 'preact';
import * as BaseComp from 'components/bolt/expandableTextList/expandableTextList.js';
// import s from 'components/bolt/expandableTextList/expandableTextList.sss';
import { observeScroll, unobserveScroll } from 'utils/scrollObserver';

import Section from 'components/bolt/section/section';
import Question from 'components/bolt/expandableTextList/question';
import s from 'components/bolt/expandableTextList/expandableTextList.sss';
import HTML from 'components/core/html/html';
import { joinClasses, sortObjectByOrder } from 'utils/utils';
import { onMarkdownClick } from 'utils/bolt';
import Store from 'store/store';
import { getDynamicData } from 'utils/bolt/dynamicData';

export default class ExpandableTextList extends BaseComp.default {

	async componentDidMount() {
		super.componentDidMount?.();

		const { appData } = Store.get();
		if (appData?.options?.cmsManaged) {
			const activePage = Store.get().activePage;
			switch (activePage) {
				case 'filmmakersStrategies':
					await this.loadCustomData(await getDynamicData('filmmakers-strategies'));
					break;
				case 'composersInitiative':
					await this.loadCustomData(await getDynamicData('composers-initiative'));
					break;
			}
		}

		observeScroll(this.base, { once: true });
	}

	componentWillUnmount() {
		super.componentWillUnmount?.();

		unobserveScroll(this.base);
	}

	changeActiveKey(key) {
		const { activeKey } = this.state;
		if (key !== activeKey) {
			this.setState({ activeKey: key });

			Store.emit('CUSTOM_EVENT', {
				category: this.props.id,
				action: 'faq-click',
				label: key
			});
			
		} else {
			this.setState({ activeKey: null });
		}
	}

	async loadCustomData(dynamicData) {
		if (!dynamicData) return;

		const faq = dynamicData?.faq;
		if (!faq) return;

		const mapFaqItems = (items) => {
			return items?.map((item, index) => {
				const hasNested = Array.isArray(item.nestedQuestions) && item.nestedQuestions.length > 0;
				return {
					type: 'question',
					question: item.title,
					answer: item.description,
					order: index,
					nestedQuestions: hasNested ? mapFaqItems(item.nestedQuestions) : undefined
				};
			}) || [];
		};

		const questions = mapFaqItems(faq.touts);

		this.dynamicData = {
			enabled: faq.enabled,
			title: faq.title,
			description: faq.description,
			questions: sortObjectByOrder(questions)
		};

		this.setState({});
	}

	isEnabled() {
		return this.dynamicData?.enabled ?? this.getPageData()?.enabled ?? true;
	}

	getTitle() {
		return this.dynamicData?.title || this.getPageData().title;
	}

	getDescription() {
		return this.dynamicData?.description || this.getPageData().description;
	}

	getQuestions() {
		return this.dynamicData?.questions || this.getPageData().questions;
	}

	renderQuestions() {
		const questions = this.getQuestions();
		
		return (
			<div class={s.questions} key="questions">
				{sortObjectByOrder(questions, (data, key) => {
					const { type, question, answer, nestedQuestions} = data;
					if (type === 'separator') {
						return <div class={s.separator}>{question}</div>;
					}	
					let hasNested = nestedQuestions ? true : false;
					return (
						<Question
							key={key}
							question={!!question && <HTML markdown content={question} class={question} inline />}
							answer={answer}
							isOpen={this.state.activeKey === key}
							toggleActive={() => this.changeActiveKey(key)}
							hasNested={hasNested}
							nestedQuestions={nestedQuestions}
							parentKey = {key}
							id = {this.props.id}
						/>
					);
				})}
			</div>
		);
	}

	render(props) {
		if (!this.isEnabled()) return null;
		const isSection = !!props.appData?.pages[props.id]?.section;

		return (
			<div class={joinClasses(s.wrapper, isSection && s.section)} data-section={isSection && props.id}>
				{this.renderBgContent()}
				{this.renderTitle()}
				{this.renderDescription()}
				{this.renderQuestions()}
				{this.renderOverlayedContent()}
			</div>
		);
	}
}
